module.exports = __webpack_public_path__ + "img/timber.3866301e.png";